module.exports = () => {
    const bigScreenViewMin = 1025;

    // Initially hide all accordion info
    $('.accordion__info').hide();

    $('.js-accordion-general-button').on('click', (e) => {
        const button = $(e.currentTarget);
        const accordionItem = button.closest('.accordion__item');
        const content = accordionItem.find('.accordion__info');

        // Toggle aria-expanded
        const isExpanded = button.attr('aria-expanded') === 'true';
        button.attr('aria-expanded', String(!isExpanded));

        // Toggle visibility and hidden attribute
        if (isExpanded) {
            content.slideUp('slow');
            content.prop('hidden', true);
        } else {
            content.slideDown('slow');
            content.prop('hidden', false);
        }

        accordionItem.toggleClass('open');
    });

    if ($(window).width() < bigScreenViewMin && !$('.accordions__block').hasClass('no-collapse')) {
        $('.accordions__block').hide();

        $('.js-accordion-general-mobile-button').on('click', (e) => {
            const accordionBlock = $(e.currentTarget).closest('.accordions__inner');
            accordionBlock.toggleClass('mobile-open');
            accordionBlock.find('.accordions__block').slideToggle('slow');
        });
    }
};
